import { type } from 'ramda';

const isFunction = (item) => type(item) === 'Function';
export default isFunction;
